import { useEffect, useState } from 'react';
import { GetRegistrantStatusCounts } from '@/connection/audiences/registrants';

export const useRegistrantStatusCounts = (eventUuid: string) => {
  const [statusCounts, setStatusCounts] = useState<Record<string, number> | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!eventUuid) return;

    const fetchCounts = async () => {
      setLoading(true);
      setError(null);
      try {
        const counts = await GetRegistrantStatusCounts(eventUuid);
        setStatusCounts(counts);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Failed to fetch status counts'));
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, [eventUuid]);

  return { statusCounts, loading, error };
};
